import { connect } from "react-redux";
import Component from "../components/AppMenuSearchResult";
import { goToSlide, selectSearchedTopic, setUIVisibilityState } from "../actions";
import { isSlideAvailable } from "../utils/helpers";
var mapStateToProps = function(state, _ownProps) {
    return {
        favOnly: state.uiVisibilityState.favOnly,
        isSearching: state.loading.indexOf("search") > -1,
        results: state.search.results || null,
        currentSlide: state.currentSlide,
        nodes: state.nodes,
        isCompleted: function(id) {
            return state.completed.indexOf(id) > -1;
        },
        isAvailable: function(slide) {
            return isSlideAvailable(slide, state);
        },
        getSlideStateByBonus: function(bonus) {
            var slide = state.nodes.find(function(n) {
                return bonus.owner.id === n.target_id && bonus.owner.type === n.target_type;
            });
            if (slide) {
                return [
                    isSlideAvailable(slide, state),
                    state.completed.indexOf(slide.id) > -1,
                    slide.id
                ];
            }
            return [
                false,
                false
            ];
        }
    };
};
var mapDispatchToProps = function(dispatch, _ownProps) {
    return {
        goTo: function(id) {
            dispatch(goToSlide({
                id: id
            }));
            dispatch(setUIVisibilityState({
                state: {
                    menu: false
                }
            }));
        },
        openNote: function(note) {
            dispatch(selectSearchedTopic({
                topic: note,
                app: "Note"
            }));
            dispatch(setUIVisibilityState({
                state: {
                    notes: true,
                    activityCenter: false,
                    bonusMaterial: false
                }
            }));
        },
        openTopic: function(topic) {
            dispatch(selectSearchedTopic({
                topic: topic,
                app: "Activity"
            }));
            dispatch(setUIVisibilityState({
                state: {
                    notes: false,
                    activityCenter: true,
                    bonusMaterial: false
                }
            }));
        },
        openBonus: function(id, slideId, available) {
            dispatch(goToSlide({
                id: slideId
            }));
            available && dispatch(setUIVisibilityState({
                state: {
                    notes: false,
                    activityCenter: false,
                    bonusMaterial: true
                }
            }));
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Component);
